import { useEffect, useState } from "react";
import api from "./api";

/**
 * Fetches the office address from the CMS `footer.address` field.
 * Returns the address string + a ready-to-use Google Maps embed URL.
 * Falls back to the Batley HQ on first paint and on fetch failure.
 */
const DEFAULT_ADDRESS = "Keystone Properties, 17 Commercial Street, Batley, WF17 5HJ";

const buildMapsEmbed = (address) =>
  `https://www.google.com/maps?q=${encodeURIComponent(address)}&output=embed`;

const buildMapsLink = (address) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;

export default function useFooterAddress() {
  const [address, setAddress] = useState(DEFAULT_ADDRESS);

  useEffect(() => {
    let mounted = true;
    api
      .getContentSection("footer")
      .then((res) => {
        if (mounted && res?.content?.address) {
          setAddress(res.content.address);
        }
      })
      .catch(() => {});
    return () => {
      mounted = false;
    };
  }, []);

  return {
    address,
    mapEmbedUrl: buildMapsEmbed(address),
    mapLinkUrl: buildMapsLink(address),
  };
}
